import { defineComponent as _defineComponent } from 'vue'
import { PropType, ref } from 'vue'
import { Icons } from '@/icons/icons'
import { URLS } from '@/router/routes/urlRoutes'


export default /*#__PURE__*/_defineComponent({
  __name: 'LexonBreadcrumbsComponent',
  props: {
  items: {
    type: Array as PropType<any[]>,
    required: true
  }
},
  emits: ['clicked-item'],
  setup(__props, { emit }) {

const props = __props;



const homeIcon = Icons.HOME

const numberOfItems = ref(props.items.length)

const dashboardRoute = `/${URLS.DASHBOARD}`

// EVENTS


// METHODS
const onClickItem = () => {
  emit('clicked-item')
}

function replaceDash(value: string) {
  return value.replace(/-/g, ' ')
}

return { __sfc: true,props, homeIcon, numberOfItems, dashboardRoute, emit, onClickItem, replaceDash }
}

})